import {
  SET_SIP_CONFIG,
  SET_REGISTRATION_STATUS,
  SET_ACTIVE_CALL,
  UPDATE_CALL_STATE,
  CLEAR_ACTIVE_CALL,
  SET_CALL_HISTORY,
  ADD_CALL_TO_HISTORY,
  SET_LOADING,
  SET_ERROR,
  SET_INCOMING_CALL,
  CLEAR_INCOMING_CALL,
  OPEN_CALL_FLOW,
  CLOSE_CALL_FLOW,
  SET_CALL_FLOW_STEP,
  SET_SELECTED_CHANNEL,
  SET_MIC_PERMISSION_STATUS,
  SET_ENDPOINT_PROVISION_STATUS,
  SET_WHATSAPP_PERMISSION,
  SET_CALL_FLOW_ERROR,
  SET_CALL_OWNER_TAB,
  CLEAR_CALL_OWNER_TAB,
  SET_MUTED,
} from "./actions";

const initialCallFlowState = {
  isOpen: false,
  step: "idle", // idle|setup_mic|setup_endpoint|channel_select|connecting|ringing|connected|permission_pending|error
  selectedChannel: null, // "pstn"|"whatsapp"
  leadInfo: null, // { leadId, argonautLeadId, leadName, leadPhone, conversationId }
  micPermissionStatus: "pending",
  endpointProvisionStatus: "pending",
  isFirstTimeSetup: false,
  whatsappPermission: null, // { hasPermission, isPermanent, expiresAt, isExpiringSoon }
  errorMessage: null,
};

const initialState = {
  // SIP configuration
  sipConfig: null,
  registrationStatus: "unregistered", // 'unregistered' | 'registering' | 'registered' | 'error'

  // Active call state
  activeCall: null,

  // Incoming call (when browser rings)
  incomingCall: null,

  // Call history by leadId
  callHistory: {},

  // UI state
  isLoading: false,
  error: null,

  // Call flow modal state
  callFlow: { ...initialCallFlowState },

  // Multi-tab coordination
  tabCoordination: {
    callOwnerTabId: null,
    isCallOwner: false,
  },

  // Mute state
  isMuted: false,
};

const softphoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIP_CONFIG:
      return {
        ...state,
        sipConfig: action.payload,
      };

    case SET_REGISTRATION_STATUS:
      return {
        ...state,
        registrationStatus: action.payload,
      };

    case SET_ACTIVE_CALL:
      return {
        ...state,
        activeCall: action.payload,
        error: null,
      };

    case UPDATE_CALL_STATE:
      if (!state.activeCall) return state;
      return {
        ...state,
        activeCall: {
          ...state.activeCall,
          ...action.payload,
        },
      };

    case CLEAR_ACTIVE_CALL:
      return {
        ...state,
        activeCall: null,
      };

    case SET_CALL_HISTORY:
      return {
        ...state,
        callHistory: {
          ...state.callHistory,
          [action.payload.leadId]: action.payload.calls,
        },
      };

    case ADD_CALL_TO_HISTORY: {
      const { leadId, call } = action.payload;
      const existingHistory = state.callHistory[leadId] || [];
      return {
        ...state,
        callHistory: {
          ...state.callHistory,
          [leadId]: [call, ...existingHistory],
        },
      };
    }

    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case SET_INCOMING_CALL:
      return {
        ...state,
        incomingCall: action.payload,
      };

    case CLEAR_INCOMING_CALL:
      return {
        ...state,
        incomingCall: null,
      };

    // Call Flow reducers
    case OPEN_CALL_FLOW:
      return {
        ...state,
        callFlow: {
          ...initialCallFlowState,
          isOpen: true,
          leadInfo: action.payload.leadInfo,
          isFirstTimeSetup: action.payload.isFirstTimeSetup,
        },
      };

    case CLOSE_CALL_FLOW:
      return {
        ...state,
        callFlow: { ...initialCallFlowState },
      };

    case SET_CALL_FLOW_STEP:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          step: action.payload,
        },
      };

    case SET_SELECTED_CHANNEL:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          selectedChannel: action.payload,
        },
      };

    case SET_MIC_PERMISSION_STATUS:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          micPermissionStatus: action.payload,
        },
      };

    case SET_ENDPOINT_PROVISION_STATUS:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          endpointProvisionStatus: action.payload,
        },
      };

    case SET_WHATSAPP_PERMISSION:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          whatsappPermission: action.payload,
        },
      };

    case SET_CALL_FLOW_ERROR:
      return {
        ...state,
        callFlow: {
          ...state.callFlow,
          step: "error",
          errorMessage: action.payload,
        },
      };

    // Tab coordination reducers
    case SET_CALL_OWNER_TAB:
      return {
        ...state,
        tabCoordination: {
          ...state.tabCoordination,
          callOwnerTabId: action.payload,
        },
      };

    case CLEAR_CALL_OWNER_TAB:
      return {
        ...state,
        tabCoordination: {
          callOwnerTabId: null,
          isCallOwner: false,
        },
      };

    // Mute reducer
    case SET_MUTED:
      return {
        ...state,
        isMuted: action.payload,
      };

    default:
      return state;
  }
};

export default softphoneReducer;
